import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'es',
        debug: false, // Disable debug for now
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator'],
            caches: ['cookie', 'localStorage'],
            lookupQuerystring: 'lng',
        },
        backend: {
            loadPath: `./assets/locales/{{lng}}.json`,
        },
        supportedLngs: ['es', 'en'],
        interpolation: {
            escapeValue: false,
        },
        saveMissing: false,
        react: {
            useSuspense: false,
        },
    });

// Add language change listener for debugging
i18n.on('languageChanged', (lng) => {
    console.log('[i18n] Language changed to:', lng);
});

export default i18n;
